export default __webpack_public_path__ + "static/19_30-e5a7e7e6c3015697cbc35f8a25f2c96c.png";